/**
 * Per-org pack enablement — typed wrappers over the platform pack
 * endpoints (multi-tenancy Phase B). All three are scoped to the active
 * org (X-Org-Id, set by the OrgProvider); enable/disable require admin.
 *
 *   GET  /v1/platform/packs/enabled        — the active org's enabled packs
 *   POST /v1/platform/packs/{pack}/enable  — enable (idempotent), admin-only
 *   POST /v1/platform/packs/{pack}/disable — disable, admin-only
 */

import { api } from "@/lib/api-client";

/** Mirrors orgs.EnabledPack. */
export interface EnabledPack {
  pack: string;
  enabled_at: string;
}

export const packsApi = {
  listEnabled: () =>
    api.get<{ packs: EnabledPack[] }>("/v1/platform/packs/enabled"),
  enable: (pack: string) =>
    api.post<{ pack: string; enabled: boolean }>(
      `/v1/platform/packs/${pack}/enable`,
    ),
  disable: (pack: string) =>
    api.post<{ pack: string; enabled: boolean }>(
      `/v1/platform/packs/${pack}/disable`,
    ),
};
